import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import App from './App';
import store from 'redux/store';
import './App.scss';

const rootEl = document.getElementById('root');
ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  rootEl,
);

// comment in for PWA with service worker in production mode
// registerServiceWorker();
